/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListLiteLLMInstancesSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListLiteLLMInstancesRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListLiteLLMInstancesSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListLiteLLMInstancesSecurity$outboundSchema: z.ZodMiniType<
  ListLiteLLMInstancesSecurity$Outbound,
  ListLiteLLMInstancesSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listLiteLLMInstancesSecurityToJSON(
  listLiteLLMInstancesSecurity: ListLiteLLMInstancesSecurity,
): string {
  return JSON.stringify(
    ListLiteLLMInstancesSecurity$outboundSchema.parse(
      listLiteLLMInstancesSecurity,
    ),
  );
}

/** @internal */
export type ListLiteLLMInstancesRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListLiteLLMInstancesRequest$outboundSchema: z.ZodMiniType<
  ListLiteLLMInstancesRequest$Outbound,
  ListLiteLLMInstancesRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listLiteLLMInstancesRequestToJSON(
  listLiteLLMInstancesRequest: ListLiteLLMInstancesRequest,
): string {
  return JSON.stringify(
    ListLiteLLMInstancesRequest$outboundSchema.parse(
      listLiteLLMInstancesRequest,
    ),
  );
}
